import React, { useEffect } from 'react';
import { useHistory } from "react-router-dom";

function IdleMonitor() {
  const history = useHistory();

  let idleLogout = 1000 * 60 * 60; //1 hour session
  let idleEvent;
  let idleLogoutEvent;

  /**
   * Add any other events listeners here
  **/
  const events = ['mousemove', 'click', 'keypress'];

  /**
   * @method sessionTimeout
  **/
  const sessionTimeout = () => {
    if (!!idleEvent) clearTimeout(idleEvent);
    if (!!idleLogoutEvent) clearTimeout(idleLogoutEvent);
    idleLogoutEvent = setTimeout(() => history.push('/'), idleLogout)
  };

  useEffect(() => {
    for (let e in events) {
      window.addEventListener(events[e], sessionTimeout);
    }
    return () => {
      for (let e in events) {
        window.removeEventListener(events[e], sessionTimeout);
      }
    }
  }, []);

  return (<></>)

}

export default IdleMonitor;
